// extracted by mini-css-extract-plugin
export default {"tablehead":"Tableverticals_tablehead__JhLs7","custom-striped-table":"Tableverticals_custom-striped-table__-txbr","icon":"Tableverticals_icon__twXto"};